export default [

     {
          path: '/site',
          name: 'Site',
          component: () => import("@/views/Page/Site/Site.vue"),
           meta: {
               title: '#Default# | Site',
          },
     }
];